import React from 'react';
import { motion } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
}

/* Entrada suave al hacer scroll (IntersectionObserver vía whileInView),
   siguiendo la especificación de motion de la skill minimalist-ui. */
const Reveal: React.FC<RevealProps> = ({ children, delay = 0, className, style }) => (
  <motion.div
    className={className}
    style={style}
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
